import React from 'react'
import { t } from '../../../i18n'

export interface DosingModeUsage {
  product_count: number
  dose_count: number
  products: {
    id: number
    name: string
    organization_name: string
    dose_count: number
    assigned: boolean
  }[]
}

const scope = 'dosing_mode_usage'

const DosingModeUsagePanel = ({ usage }: { usage: DosingModeUsage }) => (
  <div className="card card-robis usage-panel">
    <div className="usage-panel__label">{t('title', { scope })}</div>
    <div className="usage-panel__summary">
      {t('summary', {
        scope,
        products: t('product_count', { scope, count: usage.product_count }),
        doses: t('dose_count', { scope, count: usage.dose_count })
      })}
    </div>
    {usage.products.length === 0 ? (
      <p className="usage-panel__empty">{t('empty', { scope })}</p>
    ) : (
      <ul className="usage-panel__list">
        {usage.products.map((product) => (
          <li
            key={product.id}
            className="usage-panel__row usage-panel__row--stacked"
          >
            {product.name}
            <span className="usage-panel__organization">
              {product.organization_name}
            </span>
            <span className="usage-panel__meta">
              {t('row_dose_count', { scope, count: product.dose_count })}
              {!product.assigned && ` · ${t('no_longer_assigned', { scope })}`}
            </span>
          </li>
        ))}
      </ul>
    )}
  </div>
)

export default DosingModeUsagePanel
